import React, { useEffect } from 'react';
import WelcomeComponent from '../common/WelcomeComponent';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ROUTE_DASHBOARD } from '../navigation/constants';

function NotFound({ history }) {
    // scroll top top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const mainHeading = 'Not Found';
    const description = (
        <>
            <p>Requested page not found.</p>
        </>
    );

    const buttonText = 'Return to Dashboard';

    return (
        <WelcomeComponent
            mainHeading={mainHeading}
            description={description}
            buttonText={buttonText}
            onClick={() => {
                history.push({ pathname: ROUTE_DASHBOARD });
            }}
        />
    );
}

NotFound.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }),
};

export default withRouter(NotFound);
